module.exports = __webpack_public_path__ + "static/img/yunnan03.d46f452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/yunnan03.png
// module id = RbNw
// module chunks = 1